/**
 *
 * TrailModeCourse
 *
 */

import { findIndex } from 'lodash';
import { mapGetters, mapActions } from 'vuex';

import SharedHeader from '@/components/SharedHeader.vue';
import WayFindBar from '@/components/WayFindBar.vue';
import Footer from '@/components/Footer.vue';
import Aside from '@/components/Aside.vue';
import Player from '@/components/Player.vue';
import Spinner from '@/components/Spinner.vue';
import Trail from '@/components/Book/Trail.vue';
import Scheme from '@/components/Book/Scheme.vue';
import PZBroadcast from '@/components/Book/PZBroadcast.vue';
import { TRAIL_COURSE_ID, BROADCAST_COURSE_ID } from '../../../constants/';

export default {
  name: 'TrailModeCourse',

  components: {
    SharedHeader,
    WayFindBar,
    Footer,
    Aside,
    Player,
    Spinner,
    Trail,
    Scheme,
    PZBroadcast,
  },

  data: () => {
    return {
      // portalURL: PORTAL_URLS,
      currentVideo: {},
      isShowPlayer: false,
      TrailCourseId: TRAIL_COURSE_ID,
      BroadcastCourseId: BROADCAST_COURSE_ID,
    };
  },

  computed: {
    ...mapGetters({
      FilterData: 'TrailModeCourse/FilterData',
      Collection: 'TrailModeCourse/Collection',
      Books: 'TrailModeCourse/Books',
      ReadyToPlayVideos: 'TrailModeCourse/ReadyToPlayVideos',
      isRequest: 'TrailModeCourse/isRequest',
      Course: 'TrailModeCourse/Course',
    }),

    CourseId: function () {
      return this.$route.params.id;
    },
  },

  created() {
    this.$store.dispatch('TrailModeCourse/getTrailCourse', this.CourseId);
  },

  methods: {
    ...mapActions({ addToFavoriteList: 'TrailModeCourse/addToFavoriteList' }),

    openPlayer(bullet) {
      this.currentVideo = this.ReadyToPlayVideos.find(v => v.bulletId == bullet.bulletId);
      this.isShowPlayer = true;
    },

    closePlayer() {
      this.isShowPlayer = false;
      this.$store.commit('TrailModeCourse/REMOVE_UNFOLLOW_VIDEOS');
    },

    goToNextVideo() {
      const index = findIndex(this.ReadyToPlayVideos, this.currentVideo);
      this.currentVideo = this.ReadyToPlayVideos[index + 1];
    },

    changeBook(event) {
      let value = event.target.value;
      this.$store.commit('TrailModeCourse/FILTER_OPTIONAL_COLLECTION_BOOK', value);
    },
  },
};
